module.exports = __webpack_public_path__ + "static/media/CriticalIllness.62e1fa68.svg";